import React from 'react';
import PropTypes from 'prop-types';

const CommentInput = ({
    label,
    value,
    placeholder,
    read_only,
    onFocus,
    onBlur,
    onChange,
    onKeyDown,
}) => (
    <div
        data-comment-group
        className="m2g-customer-address-form-group m2g-customer-address-form-group--comment"
    >
        <div
            data-comment-label
            className="m2g-customer-address-form-group-label"
        >
            {label}
        </div>
        <div className="m2g-customer-address-form-group-controls m2g-form-element-group">
            <textarea
                data-comment
                data-field="comment"
                className="m2g-customer-address-comment-textarea m2g-textarea m2g-form-element--full-width"
                value={value}
                placeholder={placeholder}
                readOnly={read_only}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange}
                onKeyDown={onKeyDown}
            />
        </div>
    </div>
);

CommentInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    read_only: PropTypes.bool.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

CommentInput.defaultProps = {
    value: '',
};

export default CommentInput;
